import Template from "../../template/Template";

export default function Home() {
    return(
        <Template menuActive="Dashboard">
            <h1>PAINEL ADMINISTRATIVO SYSPROJUD</h1>
        </Template>
    );
}